<app-abstract-dialog [dialogWidth]="'800'">
    <ng-container abstract-header>
        <h3 class="abstract-dialog__header__title">{{ title }}</h3>
    </ng-container>
    <ng-container abstract-content>
        <form class="registration-wizard__step__form-wrap cell auto"
              [formGroup]="form">
            <div class="new-indication-dialog__content">
                <app-select-menu-no-label
                        [tabIndex]="0"
                        [options]="fieldOptions"
                        [requiredField]="true"
                        [fontSizeClasses]="'font-size-20'"
                        [dropdownHeight]="64"
                        [disabled]="false"
                        [placeholder]="'GENERAL.FIELD' | translate"
                        [ariaLabel]="'GENERAL.FIELD' | translate"
                        [selectedId]="selectedHealthcareField"
                        [formFieldControl]="healthcareFieldFormControl"
                        (valueChangeEvent)="onSelectFieldChange($event)">
                </app-select-menu-no-label>

                <div class="new-indication-dialog__content__language-section">
                    <div class="new-indication-dialog__content__language-section__selected">
                        <p class="new-indication-dialog__content__language-section__selected__language">{{appLanguageLabel}}</p>
                    </div>

                    <mat-form-field class="mat-form-style"
                                    [ngClass]="{'invalid error' : titleMandatoryMissing || titleMandatoryExist}"
                                    appearance="outline">
                        <mat-label>{{'GENERAL.NAME' | translate}}</mat-label>
                        <input matInput required class="input-field" type="text"
                               [formControl]="titleMandatoryFormControl"
                               [formControlName]="'titleMandatory'">
                        <div *ngIf="titleMandatoryExist" class=" error-helper messages messages__error"
                             [attr.aria-invalid]="true">
                            {{'ERRORS.EDUCATION_NAME_EXISTS' | translate}}
                        </div>
                        <div *ngIf="titleMandatoryMissing" class="error-helper messages messages__error"
                             [attr.aria-invalid]="true">
                            {{'ERRORS.EDUCATION_NAME_MISSING' | translate}}
                        </div>
                    </mat-form-field>

                    <mat-form-field class="textarea mat-form-style"
                                    [ngClass]="{'invalid error' : descriptionMandatoryMissing}" appearance="outline">
                        <mat-label>{{'GENERAL.DESCRIPTION' | translate}}</mat-label>
                        <textarea matInput required class="input-field" type="text"
                                  [required]="true"
                                  [formControl]="descriptionMandatoryFormControl">
                        </textarea>
                        <div *ngIf="descriptionMandatoryMissing" class="error-helper messages messages__error"
                             [attr.aria-invalid]="true">
                            {{'ERRORS.EDUCATION_DESCRIPTION_MISSING' | translate}}
                        </div>
                    </mat-form-field>
                </div>

                <ng-container formArrayName="newLanguageFields"
                              *ngFor="let field of newLanguageFields?.controls; let index = index">
                    <ng-container [formGroupName]="index">
                        <div *ngIf="!field.value.selectLanguageControl"
                             class="new-indication-dialog__content__language-section__selected">
                            <div class="select-language-section">
                                <app-select-menu
                                        [showDeselectedOptions]="true"
                                        [placeholder]="'GENERAL.CHOOSE_LANGUAGE' | translate"
                                        [dropdownWidth]="innerWidth < 1024 ? '' : '240px'"
                                        [labelWidth]="'1fr'"
                                        [dropdownHeight]="40"
                                        [options]="languageOptions"
                                        [selectedId]="selectedLanguage"
                                        [fontSizeClasses]="'font-size-16'"
                                        [labelText]="'GENERAL.SELECTED_LANGUAGE' | translate"
                                        [ariaLabel]="'GENERAL.SELECTED_LANGUAGE' | translate"
                                        [formFieldControl]="selectLanguageControl"
                                        [formFieldGroup]="form"
                                        (valueChangeEvent)="onLanguageChange($event)">
                                </app-select-menu>
                            </div>
                        </div>

                        <div class="new-indication-dialog__content__language-section__selected">
                            <p class="new-indication-dialog__content__language-section__selected__language">{{getLanguageNameByEnum(field.get('selectLanguageControl').value)}}</p>
                            <app-button *ngIf="field.value.selectLanguageControl"
                                        [ariaLabel]="('GENERAL.REMOVE' | translate) + ('GENERAL.BUTTON' | translate)"
                                        [cssClasses]="'icon'"
                                        [icon]="'close'"
                                        [iconColor]="'gray-08'"
                                        (buttonClicked)="onRemoveFields(index)">
                            </app-button>
                        </div>

                        <div class="new-indication-dialog__content__language-section"
                             *ngIf="field.value.selectLanguageControl">
                            <mat-form-field class="mat-form-style" appearance="outline">
                                <mat-label>{{'GENERAL.NAME' | translate}}</mat-label>
                                <input matInput required class="input-field" type="text" name="descriptionOther"
                                       [formControl]="abstractToFormControl(field.get('titleOther'))">
                                <div *ngIf="showErrorExistMessage(field.value.selectLanguageControl)"
                                     class=" error-helper messages messages__error"
                                     [attr.aria-invalid]="true">
                                    {{'ERRORS.EDUCATION_NAME_EXISTS' | translate}}
                                </div>
                                <div *ngIf="showTitleMissing(field.value.selectLanguageControl)"
                                     class="error-helper messages messages__error"
                                     [attr.aria-invalid]="true">
                                    {{'ERRORS.EDUCATION_NAME_MISSING' | translate}}
                                </div>
                            </mat-form-field>

                            <mat-form-field class="textarea mat-form-style" appearance="outline">
                                <mat-label>{{'GENERAL.DESCRIPTION' | translate}}</mat-label>
                                <textarea matInput required class="input-field" type="text"
                                          name="descriptionOther"
                                          [required]="true"
                                          [formControl]="abstractToFormControl(field.get('descriptionOther'))">
                            </textarea>
                                <div *ngIf="showDescriptionMissingMessage(field.value.selectedLanguageControl)"
                                     class="error-helper messages messages__error"
                                     [attr.aria-invalid]="true">
                                    {{'ERRORS.EDUCATION_DESCRIPTION_MISSING' | translate}}
                                </div>
                            </mat-form-field>
                        </div>
                    </ng-container>
                </ng-container>

                <div class="btn-wrapper">
                    <app-button *ngIf="showAddAnotherLanguageButton"
                                [ariaLabel]="('GENERAL.ADD_LANGUAGE' | translate) + ('GENERAL.BUTTON' | translate)"
                                [cssClasses]="'slim'"
                                [icon]="'add'"
                                [iconColor]="'blue-08'"
                                [labelColor]="'blue-08'"
                                (buttonClicked)="addNewTranslation()">
                        {{'GENERAL.ADD_LANGUAGE' | translate}}
                    </app-button>
                </div>
            </div>
        </form>
    </ng-container>
    <ng-container abstract-footer>
        <div class="abstract-dialog__footer__buttons-wrapper">
            <div class="abstract-dialog__footer__buttons-wrapper__btn-box">
                <app-button
                        [cssClasses]="'btn small outlined outlined__gray-07'"
                        (buttonClicked)="onCancel()">
                    {{'GENERAL.CANCEL' | translate}}
                </app-button>
            </div>
            <div class="abstract-dialog__footer__buttons-wrapper__btn-box">
                <app-button type="submit"
                            [cssClasses]="'btn small solid__blue-07'"
                            (buttonClicked)="onCreate()">
                    {{actionButtonText}}
                </app-button>
            </div>
        </div>
    </ng-container>
</app-abstract-dialog>
